import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Location } from "../location";
import {
  Http,
  Response,
  Headers,
  URLSearchParams,
  RequestOptions
} from "@angular/http";
import { Observable } from "rxjs";
import { Port } from "./model/port";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import * as L from "leaflet";
import { PortSearchForm } from "../offrecommerciale/model/form/portSearchForm";
import { Geoserver } from "../geoserver/model/geoserver";
import { AbstractLrmService } from "../common/abstractlrmService";
import { Pays } from "./model/pays";

@Injectable()
export class PortService extends AbstractLrmService {
  //Create constructor to get Http instance
  constructor(http: Http) {
    super(http);
  }

  //Récupèrer tous les ports depuis le référentiel all ports
  getAllPorts(searchForm: PortSearchForm): Observable<Port[]> {
    let endPoint: string = "/ports";
    return this.getRequest(endPoint);
  }

  //Récupèrer tous les pays depuis le référentiel all pays
  getAllPays(): Observable<Pays[]> {
    let endPoint: string = "/pays";
    return this.getRequest(endPoint);
  }

  getPortsByForm(searchForm: PortSearchForm): Observable<Port[]> {
    let endPoint: string = "/ports";
    return this.postRequest(endPoint, searchForm);
  }

  getAllPortsTouches(): Observable<Port[]> {
    let form: PortSearchForm = new PortSearchForm(null, null);
    let endPoint: string = "/portsTouches";
    return this.postRequest(endPoint, form);
    // return this.getRequest(endPoint);
  }

  //Récupèrer tous les pays depuis le référentiel all pays
  getGeoserverUrl(): Observable<Geoserver> {
    let endPoint: string = "/geoServerUrl";
    return this.getRequest(endPoint);
  }
  //Récupèrer un port à partir de son identifiant
  getPortById(idport: any): Observable<Port[]> {
    let endPoint: string = "/portById?idport=" + idport;
    return this.getRequest(endPoint);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/port/port.service.ts